import apiSlice from "./apiSlice";
const manpowerApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getAllManpower: builder.query({
            query: (req) => ({
                url: `manpower/Tracking`,
                params: req
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["AllManpower"],
        }),
        getPendingManpower: builder.query({
            query: (req) => ({
                url: `manpower/Pending`,
                params: req
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["PendingManpower"],
        }),
        updateManpower: builder.mutation({
            query: ({ body }) => ({
                url: `manpower/update-actual`,
                method: 'PUT',
                body,
            }),
            invalidatesTags: ['AllManpower']
        }),
        updateManpowerStatus: builder.mutation({
            query: (body) => ({
                url: `manpower/UpdateStatus`,
                method: "POST",
                body,
            }),
            invalidatesTags: ['PendingManpower']
        }),
        getSubmittedManpower: builder.query({
            query: (req) => ({
                url: `manpower/Submitted`,
                params: req
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
        }),
    }),
});

export const { useGetAllManpowerQuery, useUpdateManpowerMutation, useUpdateManpowerStatusMutation, useGetPendingManpowerQuery, useGetSubmittedManpowerQuery } = manpowerApiSlice;
